// extracted by mini-css-extract-plugin
export default {"passButton":"styles_passButton__cz133","failButton":"styles_failButton__RL+n0","buttonText":"styles_buttonText__oAC2Z"};